<template>
  <el-row class="base_table">
    <el-row class="icon_cla" v-if="showTableMenu">
      <span style="margin-right:10px"> <slot name="tableTip"></slot></span>

      <el-popover placement="bottom" width="200" trigger="click">
        <el-checkbox-group v-model="checkedLabels">
          <el-checkbox
            v-for="label in labels"
            :label="label"
            :key="label"
            style="display:block"
            @change="handlecheckedLabelsChange(label, $event)"
          >
            {{ label }}
          </el-checkbox>
        </el-checkbox-group>
        <i class="zk-icon-funnel cur_cla" slot="reference"></i>
      </el-popover>
    </el-row>

    <el-table
      v-if="height"
      :data="data"
      :stripe="stripe"
      :height="height + 'px'"
      :highlight-current-row="highlightCurrentRow"
      @selection-change="selected"
      @row-click="rowClick"
      @current-change="handleCurrentChange"
      ref="zktable"
      v-loading="loading"
      element-loading-text="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.7)"
    >
      <template v-for="item in showColumn">
        <el-table-column
          v-if="item.type != undefined"
          :type="item.type"
          :width="60"
          :key="item.type"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="isRender(item)"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth"
        >
          <template slot-scope="scope">
            <div v-if="item.render">
              <renderRow
                :row="scope.row"
                :column="item"
                :render="item.render"
              />
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <el-table
      v-else
      :data="data"
      :stripe="stripe"
      :highlight-current-row="highlightCurrentRow"
      @selection-change="selected"
      @row-click="rowClick"
      @current-change="handleCurrentChange"
      ref="zktable"
      v-loading="loading"
      element-loading-text="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.7)"
    >
      <template v-for="item in showColumn">
        <el-table-column
          v-if="item.type != undefined"
          :type="item.type"
          :width="60"
          :key="item.type"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="isRender(item)"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth"
        >
          <template slot-scope="scope">
            <div v-if="item.render">
              <renderRow
                :row="scope.row"
                :column="item"
                :render="item.render"
              />
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </el-row>
</template>
<script>
import renderRow from './renderRow.js'
export default {
  name: 'ZkTable',
  data() {
    return {
      labels: [],
      checkedLabels: []
    }
  },
  props: {
    headerAlign: {
      type: String
    },
    data: {
      type: Array,
      default: function() {
        return []
      }
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    showTableMenu: {
      type: Boolean,
      default: false
    },
    // 表格一些样式属性
    stripe: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number
    },
    border: {
      type: Boolean,
      default: true
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    renderRow
  },
  computed: {
    showColumn() {
      return this.columns
    }
  },
  watch: {
    columns: {
      handler(val) {
        this.columns = val
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.isShowColumn(this.columns)
  },
  methods: {
    isShowColumn(column) {
      column.forEach(item => {
        if (item.visiable) {
          this.labels.push(item.label)
        }
      })
    },

    isRender(item) {
      return !item.visiable
    },

    // 处理选中的label
    handlecheckedLabelsChange(value, e) {
      this.columns.some(item => {
        if (item.label === value) {
          item.visiable = !e
        }
      })
    },

    convertedEvent(event, arg) {
      this.$emit(event, arg)
    },
    selected(selection) {
      this.$emit('selection-change', selection)
    },
    rowClick(row, column, event) {
      this.$emit('rowClick', row, column, event)
    },
    handleCurrentChange(row) {
      this.$emit('current-change', row)
    },
    btnEvent(event, params) {
      this.$emit(event, params)
    },
    setCurrentRow(row) {
      this.$refs.zktable.setCurrentRow(row)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
/deep/ .el-loading-spinner i {
  font-size: 30px;
}
.cur_cla {
  cursor: pointer;
  &:hover {
    color: @themeColor;
  }
}
.base_table {
  .icon_cla {
    float: right;
    position: relative;
    .dropdown_cla {
      width: auto;
      height: auto;
      padding: 10px;
      position: absolute;
      right: 0;
      z-index: 999;
      background: #fff;
      border-radius: 6px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
      -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    }
  }
  .el-checkbox-group {
    label {
      display: block;
      margin: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/table/src/main.vue